import lazyRetry from 'lib/lazyRetry';
import React, { lazy } from 'react';
import { Route } from 'react-router-dom';

const SolarPage = lazy(() => lazyRetry(() => import('./SolarPage')));

export const routes = [<Route key="1" exact path="/projects/:projectId/solar" component={SolarPage} />];
